import React from 'react';
import { UserSidebar } from './UserSidebar';
import { UserDashboardOverview } from './UserDashboardOverview';

interface UserDashboardProps {
    onLogout: () => void;
}

const UserDashboard: React.FC<UserDashboardProps> = ({ onLogout }) => {
    return (
        <div className="relative flex size-full min-h-screen flex-col group/design-root overflow-x-hidden bg-slate-100" style={{fontFamily: 'Inter, "Noto Sans", sans-serif'}}>
            <div className="layout-container flex h-full grow flex-col">
                <div className="gap-1 px-6 flex flex-1 justify-center py-5">
                    <UserSidebar onLogout={onLogout} />
                    <UserDashboardOverview />
                </div>
            </div>
        </div>
    );
};

export default UserDashboard;
